import React, { useState } from "react";
import "./Styles.css";
import { FaCheckCircle } from "react-icons/fa";
import phone from "../assets/logo24.png"; // optional image

export default function CTASection() {
  const [email, setEmail] = useState("");

  return (
    <div className="cta-container">
      <div className="cta-card">

        {/* LEFT */}
        <div className="cta-left">
          <p className="cta-tag">BE THE FIRST TO KNOW</p>

          <h2 className="cta-title">
            Get early access to our{" "}
            <span>upcoming products</span>
          </h2>

          {/* INPUT */}
          <div className="cta-input-group">
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button>Join Waitlist</button>
          </div>

          {/* FEATURES */}
          <div className="cta-features">
            <div><FaCheckCircle /> Early access</div>
            <div><FaCheckCircle /> Product updates</div>
            <div><FaCheckCircle /> Exclusive invites</div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="cta-right">
          <img src={phone} alt="phone" />
        </div>

      </div>
    </div>
  );
}